import yup from '../../../config/yup';

export const salesforceBulkWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('salesforceBulkWriter'),
  onError: yup.string(),
  delayedRead: yup.boolean(),
  properties: yup.object().shape({
    apiVersion: yup.string(),
    upsert: yup.boolean(),
    externalIdFieldName: yup.string(),
    useBearerToken: yup.boolean().default(false),
    batchSize: yup.string().matches(/^\d*$/, 'Batch Size must be a number'),
    username: yup.string().when('useBearerToken', {
      is: false,
      then: () => yup.string().required('Username is required when bearer token is not used'),
      otherwise: () => yup.string().notRequired(),
    }),
    password: yup.string().when('useBearerToken', {
      is: false,
      then: () => yup.string().required('Password is required when bearer token is not used'),
      otherwise: () => yup.string().notRequired(),
    }),
    isSandbox: yup.boolean(),
    sfObject: yup.string().required('Salesforce Object is required'),
    isSerial: yup.boolean(),
  }),
});
